import React, { useState, useEffect } from "react";
import BASE_URL from "../../config";
export default function Contactus() {

  const [form, setForm] = useState({
    address: "",
    phone1: "",
    phone2: "",
    timing: ""
  });

  // 🔄 Fetch existing data
  useEffect(() => {
    fetch(`${BASE_URL}/api/getContact.php`)
      .then(res => res.json())
      .then(data => {
        if (data) {
          setForm({
            address: data.address || "",
            phone1: data.phone1 || "",
            phone2: data.phone2 || "",
            timing: data.timing || ""
          });
        }
      });
  }, []);

  // ✏️ Handle input
  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  // 🚀 Submit (Insert or Update)
  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("address", form.address);
    formData.append("phone1", form.phone1);
    formData.append("phone2", form.phone2);
    formData.append("timing", form.timing);

    fetch(`${BASE_URL}/api/saveContact.php`, {
  method: "POST",
  body: formData
})
  .then(res => res.text())
  .then(msg => {
    console.log("Server response:", msg); // 👈 ADD THIS
    alert(msg);
  })
  .catch(err => console.error("Fetch error:", err));
  };

  return (
    <div className="form-container">
      <h2>સંપર્ક વિગતો</h2>

      <form className="form" onSubmit={handleSubmit}>

        <label>સરનામું</label>
        <textarea
          rows="3"
          name="address"
          placeholder="સરનામું"
          value={form.address}
          onChange={handleChange}
          required
        />

        <label>ફોન નંબર 1</label>
        <input
          type="text"
          name="phone1"
          placeholder="ફોન નંબર 1"
          value={form.phone1}
          onChange={handleChange}
          required
        />

        <label>ફોન નંબર 2</label>
        <input
          type="text"
          name="phone2"
          placeholder="ફોન નંબર 2"
          value={form.phone2}
          onChange={handleChange}
          required
        />

        <label>કામકાજ નો સમય</label>
        <input
          type="text"
          name="timing"
          placeholder="કામકાજ નો સમય"
          value={form.timing}
          onChange={handleChange}
          required
        />

        <button type="submit">Submit</button>
      </form>
    </div>
  );
}